import React from 'react';
import { atom, loadable, useAtom, useAtomValue } from '@exodus/headless-ui';
import Select from '../select/index.js';
import { toAssetAtom, toAssetsAtom, toWalletAccountAtom } from '../../../atoms/index.js';
import { partition } from '@exodus/basic-utils';
const toWalletAccountAtoms = atom((get, { selectors }) => {
    const asset = get(toAssetAtom);
    const getWalletAccount = get(selectors.walletAccounts.get);
    const enabledWalletAccounts = get(selectors.walletAccounts.enabled);
    const assetNamesByWalletAccount = get(selectors.assetSources.availableAssetNamesByWalletAccount);
    return enabledWalletAccounts
        .filter((walletAccount) => assetNamesByWalletAccount[walletAccount]?.has(asset.name))
        .map(getWalletAccount);
});
const handleSearch = async (exodus, query, walletAccount) => {
    if (query.length < 3)
        return [];
    const tokens = await exodus.exchange.searchAssets({ walletAccount, query });
    const assetDescriptors = tokens.map((token) => {
        const assetId = Object.values(token.meta ?? {})[0];
        return assetId
            ? { assetId, baseAssetName: token.network, isToken: true }
            : { baseAssetName: token.network, isToken: false };
    });
    const [tokensToFetch, baseAssetsToFetch] = partition(assetDescriptors, (v) => v.isToken);
    const [fetchedTokens, ...fetchedBaseAssets] = await Promise.all([
        exodus.assets.fetchTokens(tokensToFetch.map((v) => ({ assetId: v.assetId, baseAssetName: v.baseAssetName }))),
        ...baseAssetsToFetch.map(async (v) => {
            try {
                return await exodus.assets.getAsset(v.baseAssetName);
            }
            catch (error) {
                console.error('Error fetching base asset', error);
                return null;
            }
        }),
    ]);
    return [...fetchedBaseAssets.filter((v) => !!v), ...fetchedTokens];
};
const ToSelect = ({ Component, onSelect, ...rest }) => {
    const toAssets = useAtomValue(loadable(toAssetsAtom));
    const toWalletAccounts = useAtomValue(toWalletAccountAtoms);
    const [toWalletAccount, setToWalletAccount] = useAtom(toWalletAccountAtom);
    return (React.createElement(Select, { side: "to", Component: Component, assets: toAssets.data ?? [], walletAccount: toWalletAccount, walletAccounts: toWalletAccounts, loading: toAssets.loading, onSearch: handleSearch, onSelect: onSelect, onWalletAccountChange: setToWalletAccount, ...rest }));
};
export default ToSelect;
